(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
// Формуємо масив зображень із слайдера
const sliderImages = Array.from(document.querySelectorAll('.slide1 img')).map(img => img.src);

// Слайдер на головній сторінці
let currentIndex = 0;
const track = document.getElementById('slider-track1');
const slides = document.querySelectorAll('.slide1');
const totalSlides = slides.length;

function getSlideWidth() {
  // Враховуємо відступ між слайдами (gap 10px)
  return slides[0].offsetWidth + 10;
}

function showSlide(index) {
  if (index < 0) {
    currentIndex = totalSlides - 1;
  } else if (index >= totalSlides) {
    currentIndex = 0;
  } else {
    currentIndex = index;
  }
  const slideWidth = getSlideWidth();
  track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
}

document.getElementById('prevSlide1').addEventListener('click', () => {
  showSlide(currentIndex - 1);
});

document.getElementById('nextSlide1').addEventListener('click', () => {
  showSlide(currentIndex + 1);
});

// Модальне вікно з можливістю навігації
let modalIndex = 0;
const modalOverlay = document.getElementById('modalOverlay1');
const modalImage = document.getElementById('modalImage');

function updateModalImage() {
  modalImage.src = sliderImages[modalIndex];
}

document.querySelectorAll('.slide1 img').forEach((img, idx) => {
  img.addEventListener('click', () => {
    modalIndex = idx;
    updateModalImage();
    modalOverlay.style.display = 'flex';
  });
});

document.getElementById('modalPrev1').addEventListener('click', (e) => {
  e.stopPropagation();
  modalIndex = (modalIndex - 1 + sliderImages.length) % sliderImages.length;
  updateModalImage();
});

document.getElementById('modalNext1').addEventListener('click', (e) => {
  e.stopPropagation();
  modalIndex = (modalIndex + 1) % sliderImages.length;
  updateModalImage();
});

// Закриття модального вікна при кліку поза зображенням
modalOverlay.addEventListener('click', (e) => {
  const modalContent = document.querySelector('.modal-content1');
  if (!modalContent.contains(e.target)) {
    modalOverlay.style.display = 'none';
  }
});


// Закриття по кнопці ×
document.getElementById('modalClose1').addEventListener('click', () => {
  modalOverlay.style.display = 'none';
});

// Опціонально: ESC клавіша для закриття
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    modalOverlay.style.display = 'none';
  }
});

  } catch(e) { console.error(e); }
})();
})();
